module.exports = __webpack_public_path__ + "img/USB.4d3263aa.svg";